







import PopulateDynamically from './PopulateDynamically'

export default {
	name: 'Root',
	props: [
		'field',
	],
	components: {
		PopulateDynamically
	},
	methods: {
		refresh: function () {
			this.$refs.choices.initialLoad();
			this.$refs.values.initialLoad();
		},
	}
}
